import React from "react";
import { motion } from "framer-motion";
import FloatingDecor from "./FloatingDecor";
import OmSymbol from "./OmSymbol";

/**
 * Reusable premium page hero used across interior pages
 * (About, Contact, Services, Blog, Marketplace).
 */
export default function PageHero({ eyebrow, title, subtitle, children }) {
  return (
    <section className="relative bg-hero-gradient bg-mandala text-white py-16 text-center overflow-hidden">
      <div className="absolute inset-0 bg-gold-radial pointer-events-none" />
      <FloatingDecor variant="om" />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="relative max-w-3xl mx-auto px-4"
      >
        {eyebrow && (
          <span className="eyebrow-chip bg-gold-500/15 border border-gold-300/40 text-gold-200 mb-3">
            <span className="w-1.5 h-1.5 rounded-full bg-gold-300" />
            {eyebrow}
          </span>
        )}
        <h1 className="font-heading text-4xl sm:text-5xl mb-3">{title}</h1>
        <div className="gold-divider my-5">
          <span className="inline-flex text-gold-300"><OmSymbol size={24} /></span>
        </div>
        {subtitle && <p className="text-gold-100/90 max-w-2xl mx-auto">{subtitle}</p>}
        {children && <div className="mt-6">{children}</div>}
      </motion.div>
    </section>
  );
}
